import React from "react";
import {
  committe_background,
  committe_image,
  pattern_bg,
  thileepan_img,
  aravinthan_img,
  sansajan_img,
} from "../Constants/Data";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
const committeeMembers = [
   { name: "Aravinthan", role: "Prefect of Games", image: aravinthan_img },
  { name: "Thileepan", role: "Master in Charge", image: thileepan_img },
  { name: "Sansajan", role: "Coach", image: sansajan_img },
];

function CommitteeMembers() {
  return (
    <>
      {/* background patter */}
      <div className="w-full flex justify-end ">
        <img
          src={pattern_bg}
          alt=""
          className="absolute -z-10 md:h-[553px] lg:h-auto "
        />
      </div>

      <div className="py-[80px] md:px-[24px] px-[16px] h-full font-Rubik border-t-[#E5DADA]  border-[1px]  overflow-hidden relative">
        <div className="container mx-auto">
          <div className="flex flex-col ga[32px]">
        <div className="flex flex-col gap-[12px]">
              <div className=" flex flex-col gap-[12px] italic ">
                <h4 className="md:text-[32px] text-[20px]  leading-[24px] text-[#B72828]">
                  MEET OUR
                </h4>
                <h2 className="md:text-[48px] text-[28px]  font-medium text-[#A50808] ">
                  ADMINISTRATIVE COMMITTEE MEMBERS
                </h2>
              </div>
              <p className="text-[16px] text-[#525252]">
                The Administrative Committee of St. John’s College, Jaffna, provides 
                the strategic leadership and vision necessary to uphold our 200-year 
                legacy of excellence. Composed of dedicated professionals and educators, 
                this body ensures the seamless integration of our core values into every 
                facet of college life. Together, they work to empower our students and faculty, 
                fostering a nurturing environment where the next generation of Johnians can truly soar.

              </p>
            </div>
          <div className="committeemembers-contents flex flex-col md:gap-[32px] gap-[10px] relative overflow-x-auto highlights-scroll ">
            
            {/* mobile swiper */}
            <div className="md:hidden">
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper flex justify-end l w-full h-[350px]   object-cover"
              >
                {committeeMembers.map((member, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="committee-card flex relative rounded-[8px] justify-end  items-end h-[310px] text-start text-white font-Rubik object-cover "
                      style={{
                        backgroundImage: `url(${committe_background})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <img
                        src={member.image}
                        alt=""
                        className="h-[325px] rounded-br-[8px]"
                      />

                      <div className="committee-box z-10 w-full px-[16px] py-[8px] rounded-b-[8px] absolute ">
                        <h4 className="text-[#DBDBDB] italic font-light">
                          {member.role}
                        </h4>
                        <h3 className="font-medium text-[22px]">
                          {member.name}
                        </h3>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
{/* desktop grid */}
            <div className=" hidden md:flex  w-[1900px]   py-[32px]    gap-[28px]">
              {committeeMembers.map((member, index) => (
                <div
                  key={index}
                  className="committee-card flex relative w-[275px] rounded-[8px] md:justify-end justify-start items-end h-[310px]  text-start text-white font-Rubik object-cover "
                  style={{
                    backgroundImage: `url(${committe_background})`,

                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <img
                    src={member.image}
                    alt=""
                    className="h-[325px]  rounded-br-[8px] "
                  />

                  <div className="committee-box z-10 w-full px-[16px] py-[8px] rounded-b-[8px]  absolute ">
                    <h4 className="text-[#DBDBDB] italic font-light">
                      {" "}
                      {member.role}
                    </h4>
                    <h3 className="font-medium text-[22px] uppercase">{member.name}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default CommitteeMembers;
